import { HiX } from "react-icons/hi";
import { translate } from "ui/i18n";

export function CloseButton({
  onClick,
  hideText,
  alternativeText,
  className,
  light,
  size = 20,
}: {
  onClick: () => void;
  hideText?: boolean;
  alternativeText?: string;
  className?: string;
  light?: boolean;
  size?: number;
}) {
  return (
    <>
      <button onClick={onClick} className={`z-50 flex h-5 items-center ${className}`}>
        <HiX
          size={size}
          className={light ? "text-white" : "text-darkGrey-800"}
        />
        {!hideText && (
          <span
            className={`ms-2 text-[14px] font-bold leading-none ${
              light ? "text-white" : "text-darkGrey-800"
            }`}
          >
            {alternativeText || translate("ns1:Button.Close")}
          </span>
        )}
      </button>
    </>
  );
}
